<template>
    <div class="subPage">
        <div class="nomal_box">
            <!-- 头部信息（姓名、签名） -->
            <Header :userInfo="userInfo"/>
        </div>
        <!-- 排名信息 -->
        <Rank class="rank" :rank="userInfo.memberNo" :rankText="'本周排名'" :ownRank="ownRank"/>
        <!-- 微信二维码 -->
        <WxQrcodeCard
            :userInfo="userInfo"
        />

        <!--退出登录 我这是我随便加的样式要改一下 -->
        <router-link to="/school/logout">
        <div class="logoutContainer">
            <mt-button class="logout" >退出登录</mt-button>
        </div>
        </router-link>

        <div class="feedBackContainer">
		    <BindingPhone :phone="userInfo.phone" />
		</div>

        <!-- 意见反馈 -->
        <router-link to="/user/feedBack">
            <div class="feedBackContainer">
                <FeedBack />
            </div>
        </router-link>
        <!-- 占位 -->
        <Empty />
        <!-- 从相册中选择 -->
        <!-- <mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet> -->
        <!-- 隐藏的上传组件 -->
        <!-- <input
            id="upload"
            type="file"
            accept="image/*"
            capture="camera"
            @change="onFileChange"
        /> -->
      <go-back-home/>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Header from '../userDetailElement/Header';
import Rank from '../userElement/Rank';
import WxQrcodeCard from '../userDetailElement/WxQrcodeCard';
import FeedBack from '../userDetailElement/FeedBack';
import BindingPhone from '../userDetailElement/BindingPhone';
import Empty from '../comm/Empty';
import Upload from '../comm/Upload';

export default {
  name: 'UserDetail',
  meta:{page:true},
  computed: {
        ...mapGetters('userinterface', {
            menuTypes: 'getMenuType',
        }),
        ...mapGetters('user', {
            userInfo: 'getUserInfo',
            ownRank: 'getOwnRank'
        }),
  },
  created() {
       this.$store.dispatch('user/getUserInfo');
  },
  data() {
    return {
        sheetVisible: false,
        actions: [
            {
                name: '选择图片',
                method: this.openAlbum
            }
        ],
    }
  },
  methods: {
      openAlbum() {
        // 触发上传头像
        console.log(document.getElementById("upload"));
        document.getElementById("upload").click();
      },
      onFileChange(files) {
          console.log(files);
      }
  },
  components: {
      Header,
      Rank,
      WxQrcodeCard,
      FeedBack,
      BindingPhone,
      Empty
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.rank {
    margin-top: -0.35rem;
}
.feedBackContainer {
    color: #000;
    text-decoration-line: none;
}
.logoutContainer {
    width: 90%;
    padding: 0 5%;
}
.logout {
    width: 100%;
    background: #009688;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/page/UserDetail.vue